import {
    API_ROOT,
    API_UCENTER
} from 'apiConfig'

var api = {
    accounts: API_ROOT.concat('/getMyAccount'),
    accountInfo: API_ROOT.concat('/getAccountInfo'),
    symbolList: API_ROOT.concat('/getSymbolList'),
    mySymbolList: API_ROOT.concat('/getMySymbol'),
    modifySymbol: API_ROOT.concat('/modifySymbol'),
    searchList: API_ROOT.concat('/getHistorySearchList'),
    deleteAccount: API_ROOT.concat('/deleteAccount'),
    brokers: API_ROOT.concat('/getBrokerList'),
    bindAccount: API_ROOT.concat('/bindingAccount'),
    addVitualAccount: API_ROOT.concat('/createDemoAccount'),
    myAttention: API_ROOT.concat('/myFollow'),
    // myAttention: '/json/ucenter/myAttentions.json',
    cancelAttention: API_ROOT.concat('/cancelFollow'),
    myCollection: API_ROOT.concat('/myCollect'),
    myQuestions: API_ROOT.concat('/myQuestion'),
    commentQuestion: API_ROOT.concat('/setScore'),
    myOrders: API_ROOT.concat('/myDocumentary'),
    cancelFollow: API_ROOT.concat('/removeDocmentary'),
    userInfo: API_ROOT.concat('/getUserInfo'),
    modifyUserInfo: API_ROOT.concat('/settings'),
    analystBasicInfo: API_ROOT.concat('/analyst'),
    noticeList: API_ROOT.concat('/getNoticeList'),
    uploadFile: API_ROOT.concat('/uploadFiles'),
    getTags: API_ROOT.concat('/getTagAndCategory'),
    submitArticle: API_ROOT.concat('/submitArticle'),
    articleList: API_ROOT.concat('/articleList'),
    unPublishArticle: '/json/ucenter/unPublishArticle.json',
    publishDynamic: API_ROOT.concat('/publishTrends'),
    analystCertify: API_ROOT.concat('/analystAuth'),
    expertAreas: API_ROOT.concat('/getExpertIn'),
    brokerInfo: API_ROOT.concat('/broker'),
    uploadTextAd: API_ROOT.concat('/publishTextAds'),
    uploadImgAd: API_ROOT.concat('/publishImgAds'),
    brokerOrganizations: API_ROOT.concat('/getSuperviseOrganize'),
    myOpenTradeList: API_ROOT.concat('/getOpenOrderList'),
    myHistoryList: API_ROOT.concat('/getTradingHistory'),
    openOrder: API_UCENTER.concat('/openOrder'),
    closeOrder: API_ROOT.concat('/closeOrder'),
    cancelCollect: API_ROOT.concat('/cancelCollect'),
    setEaScore: API_ROOT.concat('/setEaScore'),
    checkEmail: API_ROOT.concat('/checkEmail'),
    checkPhone: API_ROOT.concat('/checkPhone'),
    sendPhoneCode: API_ROOT.concat('/sendPhoneCode'),
    sendEmailCode: API_ROOT.concat('/sendEmailCode'),
    modifyTelephone: API_ROOT.concat('/modidyPhone'),
    modifyEmail: API_ROOT.concat('/modidyEmail'),
    modifyPassword: API_ROOT.concat('/modidyPassword'),
    publishArticle: API_ROOT.concat('/publishArticle'),
    articleToTop: API_ROOT.concat('/toTop'),
    deleteArticle: API_ROOT.concat('/deleteArticle'),
    getArticleInfo: API_ROOT.concat('/getNewsInfo'),
    modifyArticle: API_ROOT.concat('/modifyArticle'),
    deleteDynamic: API_ROOT.concat('/deleteDynamic'),
    getNoticeInfo: API_ROOT.concat('/getNoticeInfo'),
    getAnalystInfo: API_ROOT.concat('/getAnalystAuthInfo'),
    salonOnline: API_ROOT.concat('/salonOnline'),
    getUserQuestions: API_ROOT.concat('/getQuestionsOneToOne'),
    // getUserQuestions: '/json/askQuestions.json',
    answerQuestion: API_ROOT.concat('/answerQuestion'),
    salonOnline: API_ROOT.concat('/salonOnline'),
    salonReview: API_ROOT.concat('/salonReview'),
    getSalonQuestions: API_ROOT.concat('/getQuestions'),
    // getSalonQuestions: '/json/allAnswers.json',
    salonOnline: API_ROOT.concat('/salonOnline'),
    salonPlan: API_ROOT.concat('/getSalonPlan'),
    analystSpeak: API_ROOT.concat('/speak'),
    answerSalonQuestion: API_ROOT.concat('/answerSalonQuestion'),
    getCountryList:API_ROOT.concat('/getCountryList'),
    brokerAuth:API_ROOT.concat('/brokerAuth'),
    getBrokerAuthInfo:API_ROOT.concat('/getBrokerAuthInfo'),
    getAds: API_ROOT.concat('/getAds'),
    getAdsInfo: API_ROOT.concat('/getAdsInfo')
}

// 账户列表
export const Accounts = api.accounts

// 账户信息
export const AccountInfo = api.accountInfo

// 行情列表
export const SymbolList = api.symbolList

// 主要行情列表
export const MySymbolList = api.mySymbolList

// 修改我的自选交易品种
export const ModifySymbol = api.modifySymbol

// 获取历史记录的搜索条件
export const SearchList = api.searchList

// 删除账户
export const DeleteAccount = api.deleteAccount

// 获取经纪商列表
export const Brokers = api.brokers

// 绑定账户
export const BindAccount = api.bindAccount

// 我的关注
export const MyAttention = api.myAttention

// 取消关注
export const CancelAttention = api.cancelAttention

// 我的收藏
export const MyCollection = api.myCollection

// 我的提问
export const MyQuestions = api.myQuestions

// 对问题评分
export const CommentQuestion = api.commentQuestion

// 我的跟单
export const MyOrders = api.myOrders

// 取消跟单
export const CancelFollow = api.cancelFollow

// 个人信息
export const UserInfo = api.userInfo

// 修改个人信息
export const ModifyUserInfo = api.modifyUserInfo

// 分析师的基本信息
export const AnalystBasicInfo = api.analystBasicInfo

// 公告列表
export const NoticeList = api.noticeList

// 获取公告详情
export const GetNoticeInfo = api.getNoticeInfo

// 上传图片
export const UploadFile = api.uploadFile

// 获取上传文章时的标签列表以及栏目列表
export const GetTags = api.getTags

// 发布文章
export const SubmitArticle = api.submitArticle

// 文章列表
export const ArticleList = api.articleList

// 未发布文章
export const UnPublishArticle = api.unPublishArticle

// 发布动态
export const PublishDynamic = api.publishDynamic

// 分析师认证
export const AnalystCertify = api.analystCertify

// 分析师擅长领域
export const ExpertAreas = api.expertAreas

// 获取经纪商信息
export const BrokerInfo = api.brokerInfo

// 投放文字链广告
export const UploadTextAd = api.uploadTextAd

// 投放图片广告
export const UploadImgAd = api.uploadImgAd

// 获取经纪商监管机构
export const BrokerOrganizations = api.brokerOrganizations

// 获取我的交易中的持仓记录
export const MyOpenTradeList = api.myOpenTradeList

// 获取我的交易中的历史记录
export const MyHistoryList = api.myHistoryList

// 创建模拟账户
export const AddVitualAccount = api.addVitualAccount

// 自主下单
export const OpenOrder = api.openOrder

// 平仓
export const CloseOrder = api.closeOrder

// 取消收藏
export const CancelCollect = api.cancelCollect

// EA评分
export const SetEaScore = api.setEaScore

// 发送手机验证码
export const SendPhoneCode = api.sendPhoneCode

// 发送邮箱验证码
export const SendEmailCode = api.sendEmailCode

// 检验手机号是否可用
export const CheckPhone = api.checkPhone

// 检验邮箱是否可用
export const CheckEmail = api.checkEmail

// 修改邮箱
export const ModifyEmail = api.modifyEmail

// 修改手机号
export const ModifyPhone = api.modifyTelephone

// 修改密码
export const ModifyPassword = api.modifyPassword

// 发布文章
export const PublishArticle = api.publishArticle

// 文章置顶
export const ArticleToTop = api.articleToTop

// 删除文章
export const DeleteArticle = api.deleteArticle

// 获取文章详情
export const GetArticleInfo = api.getArticleInfo

// 修改文章
export const ModifyArticle = api.modifyArticle

// 删除动态
export const DeleteDynamic = api.deleteDynamic

// 获取分析师认证信息
export const GetAnalystInfo = api.getAnalystInfo

// 沙龙坐堂
export const SalonOnline = api.salonOnline

// 专家答疑
export const GetUserQuestions = api.getUserQuestions

// 回答问题
export const AnswerQuestion = api.answerQuestion

// 沙龙回顾
export const SalonReview = api.salonReview

// 获取分析师观点
export const GetSalonQuestions = api.getSalonQuestions

// 获取当月场次安排
export const GetSalonPlan = api.salonPlan

// 分析师发言
export const AnalystSpeak = api.analystSpeak

// 回答沙龙问题
export const AnswerSalonQuestion = api.answerSalonQuestion
// 获取国家列表
export const getCountryList = api.getCountryList

export const brokerAuth = api.brokerAuth

export const getBrokerAuthInfo = api.getBrokerAuthInfo

export const GetAds = api.getAds

export const GetAdsInfo = api.getAdsInfo



// WEBPACK FOOTER //
// ./src/service/ucenter/api/address.js